import Decimal from 'decimal.js';

/**
 * Convierte un valor a Decimal.js y formatea a la cantidad de decimales especificada de forma segura.
 * Utiliza Decimal.js para evitar errores de precisión de punto flotante en JavaScript, 
 * manteniendo consistencia con el backend.
 *
 * @param value Valor a formatear (número o string)
 * @param decimalPlaces Cantidad de decimales, por defecto 2
 * @returns string con el valor formateado
 */
export const formatDecimal = (value: number | string, decimalPlaces: number = 2): string => {
    if (value === null || value === undefined || value === '') {
        return new Decimal(0).toFixed(decimalPlaces);
    }
    
    try {
        return new Decimal(value).toFixed(decimalPlaces);
    } catch (error) {
        return new Decimal(0).toFixed(decimalPlaces);
    }
};

/**
 * Parsea un valor de forma segura a un número usando Decimal.js
 * 
 * @param value Valor a parsear
 * @returns número parseado
 */
export const safeParseFloat = (value: number | string): number => {
    if (value === null || value === undefined || value === '') {
        return 0;
    }
    try {
        return new Decimal(value).toNumber();
    } catch (error) {
        return 0;
    }
};
